module.exports = __webpack_public_path__ + "static/media/graphql.54cb2eb9.svg";